import React, { useRef } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Invoice from './Invoice';
import { FaFilePdf, FaTimes } from 'react-icons/fa';

const InvoicePreview = ({ order, onClose }) => {
    const invoiceRef = useRef();

    const handleDownloadPDF = async () => {
        if (!invoiceRef.current) return;

        try {
            const element = invoiceRef.current;
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                logging: false,
            });

            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 210;
            const pageHeight = 295;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;

            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            pdf.save(`Invoice-${order?._id || 'Order'}.pdf`);
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden flex flex-col">
                {/* Header with Actions */}
                <div className="bg-gradient-to-r from-teal-600 to-blue-500 text-white px-6 py-4 flex justify-between items-center shadow-lg">
                    <h2 className="text-xl font-bold">Invoice Preview</h2>
                    <div className="flex gap-3">
                        <button
                            onClick={handleDownloadPDF}
                            className="px-5 py-2.5 bg-white text-teal-600 rounded-lg hover:bg-gray-50 flex items-center gap-2 transition-all shadow-md hover:shadow-lg font-semibold"
                            title="Download PDF"
                        >
                            <FaFilePdf className="text-lg" />
                            <span>Download PDF</span>
                        </button>
                        <button
                            onClick={onClose}
                            className="px-5 py-2.5 bg-red-500 text-white rounded-lg hover:bg-red-600 flex items-center gap-2 transition-all shadow-md hover:shadow-lg font-semibold"
                            title="Close"
                        >
                            <FaTimes />
                            <span>Close</span>
                        </button>
                    </div>
                </div>

                {/* Invoice Content - Scrollable */}
                <div className="flex-1 overflow-y-auto bg-gray-100 p-4">
                    <Invoice ref={invoiceRef} order={order} />
                </div>
            </div>
        </div>
    );
};

export default InvoicePreview;

